const UNAVAILABLE_STRING_VALUES = new Set([
  "false",
  "none",
  "not covered",
  "not included",
  "-",
  "",
  "0.0",
  "0",
]);

const getNumericValue = (value: unknown) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : NaN;
  }

  if (typeof value !== "string") {
    return NaN;
  }

  const normalizedValue = value.replace(/,/g, "").trim();

  if (!normalizedValue) {
    return NaN;
  }

  const directNumericValue = Number(normalizedValue);
  if (Number.isFinite(directNumericValue)) {
    return directNumericValue;
  }

  const currencyNumericValue = Number(normalizedValue.replace(/[^0-9.-]/g, ""));
  return Number.isFinite(currencyNumericValue) ? currencyNumericValue : NaN;
};

export const isQuoteItemUnavailable = (value: unknown): boolean => {
  if (value === null || value === undefined || value === false) {
    return true;
  }

  if (typeof value === "string") {
    const normalizedValue = value.trim().toLowerCase();

    if (UNAVAILABLE_STRING_VALUES.has(normalizedValue)) {
      return true;
    }
  }

  const numericValue = getNumericValue(value);
  return Number.isFinite(numericValue) && numericValue <= 0;
};

export const isPositiveNumberLike = (value: unknown) => {
  const numericValue = getNumericValue(value);
  return Number.isFinite(numericValue) && numericValue > 0;
};

export const getQuoteItemPriceValue = (item?: { amount?: unknown; premium?: unknown }) => {
  if (item?.amount !== undefined && item?.amount !== null) {
    return item.amount;
  }

  return item?.premium;
};

export const shouldUseAmountForDisplay = (item: {
  value?: unknown;
  amount?: unknown;
  premium?: unknown;
}) => item?.value === true && isPositiveNumberLike(getQuoteItemPriceValue(item));

export const shouldShowQuoteItem = (item?: {
  label?: unknown;
  value?: unknown;
  amount?: unknown;
  premium?: unknown;
}) => {
  if (!item) {
    return false;
  }

  if (item.label === "Basic Cover") {
    return true;
  }

  if (item.value === true) {
    return true;
  }

  if (shouldUseAmountForDisplay(item) || isPositiveNumberLike(getQuoteItemPriceValue(item))) {
    return true;
  }

  return !isQuoteItemUnavailable(item.value);
};
